import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import type { AiConversation } from '../types/aiChat.types';
import { keys } from './keys';
import { CONVERSATION_SELECT, toAiConversation } from './useGetAiConversations';

/** One conversation, whatever its rank in the history list. null: purged or not visible. */
async function fetchAiConversation(conversationId: string): Promise<AiConversation | null> {
  const { data, error } = await apiClient
    .from('ai_conversations')
    .select(CONVERSATION_SELECT)
    .eq('id', conversationId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  return data ? toAiConversation(data) : null;
}

export function useGetAiConversation(conversationId: string | undefined) {
  return useQuery({
    queryKey: keys.conversation(conversationId ?? ''),
    queryFn: () => fetchAiConversation(conversationId!),
    enabled: !!conversationId,
  });
}
